export default __webpack_public_path__ + "media/design-system/form/assets/password-crossed-0bf9517e82a4093397fe3cde347c5c59.svg";